<template>
	<page>
		<module :drag="false">
			<module-col enable-flex>
				<div class="head flex-center">
					<m-search ref="search" column="2" :reset="false" style="width: 450px; padding: 0;" @search="updateData">
						<m-search-item label="工程师">
							<c-select ref="userSelect" name="user_ids" placeholder="请选择" async multiple @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="售后网点">
							<c-select ref="outletSelect" name="outlet_id" placeholder="请选择" async @search="searchOutlet"></c-select>
						</m-search-item>
					</m-search>

					<div class="head-date flex-grow flex-center">
						<div class="head-date-button flex-center" @click="switchHandle(-1)"><i class="tf tf-angle-left"></i></div>
						<p>{{date.format('yyyy-MM')}}</p>
						<div class="head-date-button flex-center" @click="switchHandle(1)"><i class="tf tf-angle-right"></i></div>
						<a @click="switchHandle()">回到本月</a>
					</div>

					<ul class="head-legend flex-center">
						<li class="flex-center">
							<ins style="background: #777;"></ins>
							<span>待确认</span>
						</li>
						<li class="flex-center">
							<ins style="background: #0764F5;"></ins>
							<span>待服务</span>
						</li>
						<li class="flex-center">
							<ins style="background: #02A2E9;"></ins>
							<span>服务中</span>
						</li>
						<li class="flex-center">
							<ins style="background: #00ACA9;"></ins>
							<span>已完工</span>
						</li>
					</ul>
				</div>
				<div ref="schedule" class="body flex-grow flex">
					<dl class="staff">
						<dt class="flex-start-center">全部售后工程师</dt>
						<dd>
							<ul>
								<li v-for="(item, i) in staffList" :key="i" :style="{'height': Math.max(item.timeline.length * 44 - 4 + 14, 54) + 'px'}">
									<div class="person flex-center" @click="trailHandle(item)">
										<div class="person-icon flex-center">
											<img :src="item.head_photo || require('@/assets/image/head_icon.jpg')" alt="">
										</div>
										<div class="flex-grow">
											<p class="person-info ellipsis">{{item.user_realname}}<span>{{item.outlet_name}}</span></p>
											<p class="person-count"><span>{{item.completed_order_count}}</span>/{{item.total_order_count}}</p>
										</div>
										<i class="tf person-trail">&#xe6c0;</i>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
					<div class="schedule flex-grow-auto">
						<ul class="schedule-day flex">
							<li v-for="(item, i) in dayList" :key="i" :ref="item.today ? 'today' : ''" class="flex-grow flex-column flex-center" :class="{'z-today': item.today}">
								<p>{{item.$day.getDate()}}日</p>
								<span>{{weeksName[item.$day.getDay()]}}</span>
								<div class="tag flex-column flex-end">
									<ins v-if="item.holiday_type == 1" style="color:#FF5555; background: #FBE9E9;">
                                        休
                                        <c-tooltip>
                                            <template #tip>
                                                {{item.remark}}
                                            </template>
                                        </c-tooltip>
                                    </ins>
									<ins v-else-if="item.holiday_type == 2" style="color:#0764F5; background: #E1EBF9;">
                                        班
                                        <c-tooltip>
                                            <template #tip>
                                                {{item.remark}}
                                            </template>
                                        </c-tooltip>
                                    </ins>
									<ins v-else-if="item.holiday_type != 0" style="color:#FF5555; background: #FBE9E9;">休</ins>
									<ins v-if="item.today" style="color: #fff; background: #f55;">今</ins>
								</div>
							</li>
						</ul>
						<div>
							<div v-for="(staff, i) in staffList" :key="i" class="schedule-row">
								<ul class="schedule-row-cell flex" :class="{'z-hl': moveTarget}" :style="{'height': Math.max(staff.timeline.length * 44 - 4 + 14, 54) + 'px'}" @mouseup="setOrderHandle(staff)">
									<li v-for="(item, j) in dayList" :key="j" class="flex-grow flex-center"
                                        :class="{'z-today': item.today, 'z-warn': staff.leave_application_list.includes(item.date), 'z-pause': staff.pause_application_list.includes(item.date), 'z-support': getSupportDates(staff).includes(item.date)}"
                                        :data-outlet="getSupportOutlet(staff, item.date)">
                                    </li>
								</ul>
								<div class="schedule-row-timeline" :style="{'pointer-events': moveTarget ? 'none' : 'initial'}">
									<ul v-for="(line, i) in staff.timeline" :key="i">
										<li v-for="(order, j) in line" :key="j"
											v-show="!moveTarget || moveTarget.id != order.id"
											:ref="order.id"
											class="order-bar flex-column flex-center-start"
											:class="{'z-confirm': order.member_status == 6, 'z-wait': order.member_status == 2, 'z-finish': order.member_status == 5, 'z-before': order.position.before, 'z-after': order.position.after}"
											:style="{'left': order.position.left + 'px', 'width': order.position.width + 'px'}"
											@click="globalDialog('afterSaleOrderDetail', {props: {id: order.order_id}})"
											@mouseenter="detailHandle(order, staff)"
											@mouseleave="detailHandle(null)"
										>
											<p class="ellipsis">
												<i v-if="order.urgency_level == 3" class="tf">&#xe657;</i>
												<b><c-state dict="serviceTypeDic" :value="order.service_type" :color="false"></c-state> ({{order.customer_city_name}})</b>
											</p>
											<p class="ellipsis"><i class="tf">&#xe67c;</i>{{order.customer_name}}</p>
											<div class="order-bar-tag flex">
												<ins v-if="order.dispatch_method == 2" class="order-bar-charge" style="color: #000; background: #FFDE00;"><i class="tf-assign"></i></ins>
												<ins v-if="order.is_charge == 2" class="order-bar-charge" style="color: #fff; background: #FF5555;">主</ins>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
		
				<div v-if="moveTarget"
					class="order-bar flex-column flex-center-start z-confirm z-move"
					:style="{'left': moveTarget.position.left + 'px', 'top': moveTarget.position.top + 'px', 'width': moveTarget.position.width + 'px'}"
				>
					<p class="ellipsis">
						<i v-if="moveTarget.urgency_level == 3" class="tf">&#xe657;</i>
						<b><c-state dict="serviceTypeDic" :value="moveTarget.service_type" :color="false"></c-state> ({{moveTarget.customer_city_name}})</b>
					</p>
					<p class="ellipsis"><i class="tf">&#xe67c;</i>{{moveTarget.customer_name}}</p>
				</div>

				<div v-show="detailData" ref="detail" class="card" :style="detailPosition" @mouseenter="detailHandle()" @mouseleave="detailHandle(null)">
					<template v-if="detailData">
						<div class="card-user">
							<div class="flex">
								<div class="card-user-icon flex-center">
									<img :src="detailData.dispatch_user_head_photo || require('@/assets/image/head_icon.jpg')" alt="">
								</div>
								<div class="flex-grow">
									<div class="flex-start-center">
										<p class="card-user-name">{{detailData.dispatch_user_realname}}</p>
										<ins v-if="detailData.is_charge == 2" class="card-user-tag flex-center">负责人</ins>
									</div>
									<ul class="card-user-info">
										<li class="flex">
											<label>上门服务时间：</label>
											<span>{{detailData.start_time}}</span>
										</li>
										<li class="flex">
											<label>预计服务时长：</label>
											<span>{{detailData.dispatch_days}}天</span>
										</li>
									</ul>
								</div>
							</div>
							<ul v-if="detailData.member_status == 3" class="card-user-flow flex">
								<li v-for="(item, i) in flowList" :key="i" class="flex-center flex-grow" :class="{'z-finish': item.state <= detailData.execute_status, 'z-active': item.state == detailData.execute_status + 1 && i != 3}">
									<i v-if="item.state <= detailData.execute_status" class="tf">&#xe65e;</i>
									<span>{{item.name}}</span>
								</li>
							</ul>
						</div>
						<div class="card-head flex-between-center">
							<p class="flex-grow"><a @click="globalDialog('afterSaleOrderDetail', {props: {id: detailData.order_id}})">编号：{{detailData.order_number}}</a></p>
							<c-state dict="afterSaleOrderStateDic" tag :value="detailData.status"></c-state>
							<c-state dict="serviceTypeDic" tag :value="detailData.service_type"></c-state>
							<c-state v-if="detailData.urgency_level != 1" dict="urgencyLevelDic" tag :value="detailData.urgency_level"></c-state>
						</div>
						<ul class="card-info">
                            <li class="flex">
                                <label>安装进度：</label>
                                <span v-if="!detailData.product_count || detailData.product_count==0">-</span>
                                <c-progress v-else-if="detailData.status==5" classs="flex-grow" :rate="[1, 1]" color="green"></c-progress>
                                <c-progress v-else classs="flex-grow" :rate="[detailData.completion_progress || 0, 1]"></c-progress>
                            </li>
							<li class="flex">
								<label>派单次数：</label>
								<span>
                                    {{detailData.dispatch_count}}次
                                    <span v-if="detailData.dispatch_method == 2">（手动派单）</span>
                                    <span v-else>（自动派单）</span>
                                </span>
							</li>
							<li class="flex">
								<label>客户名称：</label>
								<span>{{detailData.customer_name}}</span>
							</li>
							<li class="flex">
								<label>客户服务地址：</label>
								<span>{{detailData.customer_address}}</span>
							</li>
							<li class="flex">
								<label>工单负责人：</label>
								<span>{{detailData.charge_user_realname}}</span>
							</li>
							<li class="flex">
								<label>团队成员：</label>
								<span>{{detailData.group_user_realname ? detailData.group_user_realname.replaceAll(',', '、') : ''}}</span>
							</li>
							<li class="flex">
								<label>客户预约时间：</label>
								<span>{{detailData.appointment_start_time}}</span>
							</li>
							<li class="flex">
								<label>最后报工时间：</label>
								<span>{{detailData.today_last_report_time}}</span>
							</li>
						</ul>
						<div v-if="[6, 2].includes(detailData.member_status)" class="card-button flex">
							<!-- <a v-if="auth('b_aftersale_order_edit') && (detailData.status == 1 || detailData.status == 2 || detailData.status == 3)" class="flex-center flex-grow" @click="addOrderMember()">
								<i class="tf-auth"></i>
								<span>团队成员</span>
							</a> -->
							<a class="flex-center flex-grow" @click="editHandle(detailData)">
								<i class="tf-edit"></i>
								<span>编辑派单信息</span>
							</a>
							<a class="flex-center flex-grow" style="color: #f55;" @click="cancelOrderHandle(detailData)">
								<i class="tf-trash"></i>
								<span>取消派单</span>
							</a>
						</div>
					</template>
				</div>

				<c-dialog ref="edit" width="440">
					<c-tips>温馨提示：为防止派单信息出错，系统会记录您每次手动调整的记录，请谨慎操作</c-tips>
					<c-form ref="editForm" vertical unit-width="100%" style="padding-top: 5px;">
						<c-form-item label="上门服务时间" required>
							<c-datetime name="start_time" type="date" :min-date="editData.min_date" :max-date="editData.max_date" @change="editDateHandle"></c-datetime>
						</c-form-item>
						<c-form-item label="预计服务时长" required>
							<c-input type="stepper" name="dispatch_days" :range="[1, editData.max_days || Infinity]" append-text="天"></c-input>
						</c-form-item>
						<c-checkbox v-if="!editData.is_charge" v-model="editData.charge_state" style="margin-top: 15px;">设为工单负责人</c-checkbox>
					</c-form>
				</c-dialog>

				<c-dialog ref="trail" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
					<div class="map-legend flex-start-center">
						<c-checkbox-group v-model="currentLegend">
							<c-checkbox value="0"><div class="map-legend-item flex-center">待确认的工单<ins style="background: #777;"></ins></div></c-checkbox>
							<c-checkbox value="1"><div class="map-legend-item flex-center">待服务的工单<ins style="background: #0764F5;"></ins></div></c-checkbox>
							<c-checkbox value="2"><div class="map-legend-item flex-center">服务中的工单<ins style="background: #02A2E9;"></ins></div></c-checkbox>
							<c-checkbox value="3"><div class="map-legend-item flex-center">已完工的工单<ins style="background: #00ACA9;"></ins></div></c-checkbox>
						</c-checkbox-group>
					</div>
					<c-map ref="map" class="flex-grow"></c-map>
				</c-dialog>
			</module-col>

			<module-col ref="aside" size="350" title="未分配订单" enable-flex mini>
				<div class="order-list-tip">注：拖动工单至左侧日历，即可手工派单</div>
				<div v-if="orderList" class="flex-grow order-list">
					<c-empty v-if="!orderList.length"></c-empty>
					<div v-for="(item, i) in orderList" :key="i"
						class="order"
						@click="globalDialog('afterSaleOrderDetail', {props: {id: item.id}})"
						@mousedown="moveHandle(item)"
					>
						<div class="order-base flex-start-center">
							<i class="tf">&#xe612;</i>
							<p class="flex-grow">{{item.order_number}}</p>
							<c-state dict="serviceTypeDic" tag :value="item.service_type"></c-state>
							<c-state v-if="item.urgency_level != 1" dict="urgencyLevelDic" tag :value="item.urgency_level"></c-state>
						</div>
						<p class="order-info">
							<label>预计服务时长：</label>
							<span>{{item.estimated_service_days}}天</span>
						</p>
						<p class="order-info">
							<label>客户预约时间：</label>
							<span>{{item.appointment_start_time || '-'}}</span>
						</p>
						<p class="order-info">
							<label>客户名称：</label>
							<span>{{item.customer_name}}</span>
						</p>
						<p class="order-info">
							<label>客户地区：</label>
							<span>{{item.customer_address}}</span>
						</p>
					</div>
				</div>
			</module-col>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				orderList: null,
				staffList: [],

				weeksName: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
				date: new Date(),
				dayList: [],

				moveTarget: null,
				currentLegend: [],

				detailData: null,
				detailPosition: {},
				flowList: [{
					name: '出发',
					state: 1
				}, {
					name: '到达',
					state: 2
				}, {
					name: '服务中',
					state: 3
				}, {
					name: '完工',
					state: 3
				}, {
					name: '回网点',
					state: 4
				}],
				editData: {
					is_charge: false,
					charge_state: false
				}
			}
		},

		watch: {
			currentLegend(val) {
				this._mapMark && this._mapMark.forEach((list, index) => {
					let state = val.findIndex(item => item == index) != -1;
					list.forEach(item => {
						state ? item.show() : item.hide();
					});
				});
			}
		},

		mounted() {
			this.$bus.$emit('aftersale_order_schedule.getIds', ids => {
				this.$bus.$off('aftersale_order_schedule.getIds');
				this._ids = ids;
			});
			this.updateData(true);
			if (!this._ids) {
				this.$refs.aside.fold();
			}
		},
		
		methods: {
			switchHandle(type) {
				if (!type) {
					this.date = new Date();
				} else {
					this.date = new Date(this.date.getFullYear(), this.date.getMonth() + type, 1);
				}
				this.updateData(true);
			},
            /************搜索用户*******************************/
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        is_engineer: 1,
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
			searchOutlet(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_OUTLET',
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.outlet_name,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			trailHandle(item) {
				if (!item.order_list.length) {
					this.$message({
						message: '暂无派单数据'
					});
					return;
				}
				this.$refs.trail.open({
					title: `${item.user_realname} — 派工轨迹 (${this.date.format('yyyy年MM月')})`
				});
				this.$refs.map.init({
					resetViewport: false
				}, map => {
					map.clearOverLays();
					this._mapMark = [[], [], [], []];
					this.currentLegend = [0, 1, 2, 3];
					if (item.order_list.length) {
						let points = [];
						item.order_list.forEach((order, index) => {
							let {customer_address_longitude: lng, customer_address_latitude: lat} = order;
							let icon = require(`@/assets/image/point_state_${order.member_status}.png`);
							let dom = $([
								`<div class="marker flex-center" style="background-image: url('${icon}')">`,
									`<p>${index + 1}</p>`,
								'</div>',
							].join('')).click(() => {
								this.globalDialog('afterSaleOrderDetail', {props: {id: order.order_id}})
							});
							let mark = this.$refs.map.overlay(lng, lat, dom[0], {
								zIndex: 999,
								offsetY: '5px'
							});
							this._mapMark[order.member_status == 2 ? 1 : order.member_status == 5 ? 3 : order.member_status == 6 ? 0 : 2].push(mark);
							let point = new T.gcjLngLat(lng, lat);
							points.push(point);

							if (index) {
								let prev = item.order_list[index - 1];
								map.addOverLay(new T.Polyline([
									new T.gcjLngLat(prev.customer_address_longitude, prev.customer_address_latitude),
									point
								], {
									color: '#FF0000'
								}));
							}
						});
						map.setViewport(points);
					}
				});
			},

			updateData(init) {
				this.request({
					url: '/after/sale/order/list',
					data: {
						ids: this._ids,
						status: [1],
						pageSize: 100
					},
					success: data => {
						this.orderList = data;
					}
				});

				this._lastRequest && this._lastRequest.abort();
				this._lastRequest = this.request({
					url: '/after/sale/order/schedule/list',
					data: Object.assign({
						month: this.date.format('yyyy-MM')
					}, this.$refs.search.get()),
					success: ({date_list, user_list}) => {
						this.dayList = date_list.map(item => {
							item.$day = new Date(item.date);
							item.today = item.$day.format('yyyy-MM-dd') == new Date().format('yyyy-MM-dd');
							return item;
						});

						init && this.$nextTick(() => {
							let $today = this.$refs.today[0];
							if ($today) {
								this.$refs.schedule.scrollLeft = $today.offsetLeft - this.$refs.schedule.clientWidth / 4;
							} else {
								this.$refs.schedule.scrollLeft = 0;
							}
						});

						this.staffList = user_list.map(staff => {
							staff.timeline = [];
							staff.order_list.forEach(order => {
								let orderStart = new Date(order.start_time), orderEnd = new Date(order.end_time);
								let before = orderStart.format() < this.dayList[0].$day.format(),
									after = orderEnd.format() > this.dayList[this.dayList.length - 1].$day.format();
								let start = before ? this.dayList[0].$day : orderStart,
									end = after ? this.dayList[this.dayList.length - 1].$day : new Date(order.end_time);
								order.position = {
									left: start.getDate() * 81 - 81 + (before ? 0 : 6),
									width: (end.getDate() - start.getDate() + 1) * 81 - (before ? 0 : 6) - (after ? 0 : 6),
									before,
									after
								}

								let col = 0;
								while (true) {
									if (!staff.timeline[col]) {
										this.$set(staff.timeline, col, []);
									}
									
									let i;
									for (i = 0; staff.timeline[i]; i++) {
										if (!staff.timeline[i].find(temp => {
											return (order.start_time >= temp.start_time && order.start_time <= temp.end_time) ||
												(order.end_time >= temp.start_time && order.end_time <= temp.end_time) ||
												(order.start_time < temp.start_time && order.end_time > temp.end_time)
										})) {
											staff.timeline[i].push(order);
											break;
										}
									}
									
									if (i >= staff.timeline.length) {
										col++;
									} else {
										break;
									}
								}
							})
							return staff;
						})
					}
				});
			},

			moveHandle(order) {
				if (![1, 2].includes(order.status) || order.is_charge == 1) return;
				this._moveHandle = e => {
					if (!this.moveTarget) {
						this.detailHandle(null);
						this.moveTarget = Object.assign({}, order, {
							position: {
								left: e.clientX,
								top: e.clientY,
								width: order.estimated_service_days * 81 - 12
							}
						})
					}
					this.moveTarget.position.left = e.clientX;
					this.moveTarget.position.top = e.clientY;
				}
				this._moveEndHandle = () => {
					setTimeout(() => {
						this.moveTarget = null;
					}, 100);
					window.removeEventListener('mousemove', this._moveHandle);
					window.removeEventListener('mouseup', this._moveEndHandle);
				}
				window.addEventListener('mousemove', this._moveHandle);
				window.addEventListener('mouseup', this._moveEndHandle);
			},

			setOrderHandle(staff) {
				if (!this.moveTarget) return;

				let dataParams = {
					order_id: this.moveTarget.id,
					charge_user_id: staff.user_id,
                    member_user_ids: [staff.user_id]
				}
				
                this.request({
                    url: '/after/sale/order/dispatch/conflict',
                    data: dataParams,
                    loading: true,
                    success: (data, message) => {
                        if (data == 1) {
                            this.$confirm({
                                type: 'warn',
                                title: '排期冲突',
                                message,
                                buttonName: '继续修改',
                                cancelButtonName: '取消修改',
                                resolve: () => {
                                    this.orderDispatch(dataParams);
                                }
                            })
                        } else {
                            this.orderDispatch(dataParams);
                        }
                    }
                });
			},

            //执行派单操作
            orderDispatch(data) {
                this.request({
                    url: '/after/sale/order/dispatch',
                    data: data,
                    loading: true,
                    success: () => {
                        this.updateData();
                    }
                });
            },

			detailHandle(order, staff) {
				if (order === null) {
					this._detailRequest && this._detailRequest.abort();
					this._detailTimer = setTimeout(() => {
						this.detailData = null;
						this.detailPosition = null;
					}, 50);
				} else {
					clearTimeout(this._detailTimer);
					if (order) {
						this._detailRequest = this.request({
							url: '/after/sale/order/schedule/detail',
							data: {
								id: order.id
							},
							success: data => {
								this.detailData = data;
								let rect = this.$refs[order.id][0].getBoundingClientRect();
								let right = window.innerWidth - rect.right >= 420;
								this.$nextTick(() => {
									let target = this.$refs.detail.getBoundingClientRect();
									this.detailPosition = {
										[right ? 'left' : 'right']: (right ? rect.left : (window.innerWidth - rect.right)) + 'px',
										top: window.innerHeight - rect.top - rect.height > target.height
											? rect.top + rect.height + 'px'
											: rect.top - target.height + 'px'
									}
								});
							}
						})
					}
				}
			},

			editHandle(order) {
				this.editData = {
					id: order.id,
					is_charge: order.is_charge == 2,
					charge_state: order.is_charge == 2,
					min_date:new Date().format('yyyy-MM-dd'),
					max_date: (() => {
                        const date = new Date();
                        date.setMonth(date.getMonth() + 1);
                        return date.format('yyyy-MM-dd');
                    })(),
					max_days: Infinity
				}
				this.editDateHandle(order.start_time);
				this.$refs.editForm.set({
					start_time: order.start_time,
					dispatch_days: order.dispatch_days
				});
				this.$refs.edit.open({
					title: `编辑派单信息-${order.dispatch_user_realname}`,
					resolve: (stop, next) => {
						stop();
						this.$refs.editForm.submit({
							url: '/after/sale/order/schedule/edit',
							rule: {
								start_time: '请选择上门服务时间',
								dispatch_days: '请填写预计服务时长'
							},
							dataFormatter: data => {
								data.id = this.editData.id;
								data.is_charge = this.editData.charge_state ? 2 : 1;
								return data;
							},
							success: () => {
								next();
								this.$message({
									message: '修改成功'
								});
								this.updateData();
							}
						});
					}
				})
			},

			editDateHandle(val) {
				let days = parseInt(this.$refs.editForm.get().dispatch_days) || 0;
				let max = (new Date(this.editData.max_date).getTime() - new Date(val).getTime()) / 1000 / 60 / 60 / 24 + 1;
				this.editData.max_days = max;
				if (days > max) {
					this.$refs.editForm.set({
						dispatch_days: max
					});
				}
			},

			cancelOrderHandle(order) {
				if (order.is_charge == 2 && order.group_user_realname) {
					this.$confirm({
						message: `此工单由『${order.dispatch_user_realname}』负责，请先更换工单负责人再取消派单`,
						buttonName: '我知道了',
						cancelButton: false
					});
				} else {
					this.$confirm({
						message: '<p style="color: #f00">取消后要需要重新派单，系统将记录你此次操作，你确定要取消派单吗？</p>',
						resolve: () => {
							this.request({
								url: '/after/sale/order/cancel/dispatch',
								data: {
									id: order.id
								},
								loading: true,
								success: () => {
									this.updateData();
								}
							});
						}
					});
				}
			},
            //获取指定日期的支援网点名称（只取前两个字）
            getSupportOutlet(staff, date) {
                if (!staff.support_period_list || !date) return '';
                const period = staff.support_period_list.find(p => {
                    return date >= p.start_time && date <= p.end_time;
                });
                return period ? ('支援'+period.outlet_name.substring(0, 2) ): '';
            },
            //获取支援日期列表（兼容多种字段名）
            getSupportDates(staff) {
                return staff.temp_support_list || staff.temp_support_set || [];
            },
            //编辑团队成员
            addOrderMember() {
                this.globalDialog('aftersaleOrderMember', {
                    data: {
                        id: this.detailData.id,
                        status: this.detailData.status,
                        schedule_start_time: this.detailData.schedule_start_time
                    }
                }, this.updateData);
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.head {
		position: relative;
		height: 54px;
		border-bottom: 1px solid #ddd;
		padding: 0 10px;

		&-date {
			gap: 10px;

			&-button {
				box-sizing: border-box;
				width: 28px;
				height: 28px;
				border-radius: 4px;
				border: 1px solid #ddd;
				font-size: 13px;
				cursor: pointer;
				
				&:hover {
					position: relative;
					border-color: var(--color-main);
					color: #fff;
					background: var(--color-main);
				}
			}

			p {
				font-size: 18px;
				font-weight: bold;
			}

			a {
				font-size: 13px;
				color: #666;

				&:hover {
					color: var(--color-main);
				}
			}
		}

		&-legend {
			gap: 8px;
			margin-left: 10px;

			li {
				gap: 4px;
				font-size: 13px;
				color: #666;

				ins {
					width: 12px;
					height: 12px;
				}
			}
		}
	}

	.body {
		width: 100%;
		overflow: auto;
	}

	.staff {
		align-self: flex-start;
		z-index: 10;
		position: sticky;
		left: 0;
		box-sizing: border-box;
		min-width: 160px;
		border-right: 1px solid #eee;
		background: #fff;
		box-shadow: 0 -5px 5px 0 rgba(0,0,0,.2);

		dt {
			z-index: 10;
			position: sticky;
			top: 0;
			height: 50px;
			border-bottom: 1px solid #ddd;
			padding: 0 10px;
			font-size: 14px;
			background: #FAFAFA;
		}

		dd {
			li {
				border-bottom: 1px solid #eee;

				.person {
					gap: 6px;
					position: relative;
					height: 54px;
					padding: 0 8px;
					cursor: pointer;

					&:hover {
						background: #F5F5F5;
					}

					&-icon {
						width: 36px;
						height: 36px;
						border-radius: 18px;
						overflow: hidden;
					}

					&-info {
						margin: 4px 0 8px;
						font-size: 14px;

						span {
							margin-left: 6px;
							font-size: 12px;
							color: #999;
						}
					}

					&-count {
						font-size: 12px;
						color: #666;

						span {
							color: #00ACA9;
						}
					}

					&-trail {
						position: absolute;
						right: 4px;
						bottom: 4px;
						font-size: 16px;
						color: var(--color-main);
					}
				}
			}
		}
	}

	.schedule {
		align-self: flex-start;
		position: relative;

		&-day {
			z-index: 9;
			position: sticky;
			top: 0;

			li {
				gap: 8px;
				position: relative;
				min-width: 80px;
				height: 50px;
				border-bottom: 1px solid #ddd;
				border-right: 1px solid #ddd;
				font-size: 14px;
				background: #FAFAFA;

				&.z-today {
					border-right: 1px dashed #f55;
				}

				span {
					font-size: 12px;
					color: #999;
				}

				.tag {
					position: absolute;
					right: 0;
					top: 0;

					ins {
						display: block;
						box-sizing: border-box;
						min-width: 20px;
						padding: 0 4px;
						line-height: 20px;
						font-size: 12px;
						text-align: center;
					}
				}
			}
		}

		&-row {
			position: relative;
			border-bottom: 1px solid #eee;

			&-cell {
				background: #F7FDFF;

				&.z-hl {
					&:hover {
						background: #FFF883;
					}
				}

				li {
					position: relative;
					min-width: 80px;
					border-right: 1px solid #eee;

					&.z-today {
						border-right: 1px dashed #f55;
					}

					&.z-warn {
						background: #FFF8AF;

						&:before {
							content: '请假';
							position: absolute;
							left: 2px;
							top: 2px;
							font-size: 12px;
							color: #FF6900;
						}

						+ .z-warn:before {
							content: '';
						}
					}
                    &.z-pause {
                        background: #FFF8AF;

                        &:before {
                            content: '暂停接单';
                            position: absolute;
                            left: 2px;
                            top: 2px;
                            font-size: 12px;
                            color: #FF6900;
                        }

                        + .z-pause:before {
                            content: '';
                        }
                    }
                    &.z-support {
                        background: #EDF4FF;

                        &:before {
                            content: attr(data-outlet);
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 14px;
                            color: rgba(150, 180, 210, 0.5);
                            pointer-events: none;
                            white-space: nowrap;
                        }

                        + .z-support:before {
                            content: '';
                        }
                    }
				}
			}

			&-timeline {
				position: absolute;
				inset: 0;
				box-sizing: border-box;
				padding: 7px 0;

				ul {
					position: relative;
					height: 40px;

					&:nth-child(n+2) {
						margin-top: 4px;
					}

					.order-bar {
						opacity: .85;
						cursor: pointer;
						transition: opacity .1s ease;

						&:hover {
							opacity: 1;
						}
					}
				}
			}
		}
	}
	
	.order-bar {
		gap: 5px;
		position: absolute;
		top: 0;
		box-sizing: border-box;
		height: 40px;
		border: 2px solid #00A1E9;
		border-radius: 4px;
		padding: 0 8px;
		background: #fff;
		user-select: none;

		&.z-before {
			border-start-start-radius: 0;
			border-end-start-radius: 0;
		}

		&.z-after {
			border-start-end-radius: 0;
			border-end-end-radius: 0;
		}

		&.z-confirm {
			border-color: #777;
			background: #777;
		}

		&.z-wait {
			border-color: #0764F5;
			background: #0764F5;
		}

		&.z-finish {
			border-color: #00ACA9;
			background: #00ACA9;
		}

		&.z-move {
			z-index: 90;
			position: fixed;
			opacity: .6;
			pointer-events: none;
		}

		&-tag {
			position: absolute;
			right: -2px;
			top: -2px;
			border-radius: 0 4px 0 0;
			overflow: hidden;

			ins {
				width: 18px;
				line-height: 18px;
				font-size: 12px;
				text-align: center;
			}
		}

		p {
			width: 100%;
			font-size: 12px;
			color: #666;

			^[-1].z-confirm ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			^[-1].z-wait ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			^[-1].z-finish ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			.tf {
				margin-right: 5px;
			}

			&:nth-child(1) {
				color: #00A1E9;
			}
		}
	}

	.order-list {
		overflow: auto;
		background: #F5F5F5;

		&-tip {
			padding: 0 12px;
			line-height: 34px;
			font-size: 12px;
			color: #f55;
			background: #F5F5F5;
		}

		.order {
			position: relative;
			border-radius: 4px;
			padding: 0 14px 10px;
			margin: 0 12px 12px;
			background: #fff;
			cursor: pointer;
			user-select: none;

			&-base {
				gap: 4px;
				box-sizing: border-box;
				height: 40px;
				padding-top: 4px;

				.tf {
					font-size: 14px;
					color: var(--color-main);
				}

				p {
					font-size: 16px;
					font-weight: bold;
				}
			}

			&-info {
				line-height: 24px;
				font-size: 12px;
				color: #333;

				label {
					color: #999;
				}
			}
		}
	}

	.map-legend {
		height: 40px;
		padding: 0 22px;

		&-item {
			gap: 4px;

			ins {
				width: 20px;
				height: 6px;
			}
		}
	}

	>>> .marker {
		box-sizing: border-box;
		width: 40px;
		height: 40px;
		padding-bottom: 6px;
		font-size: 14px;
		color: #fff;
		background-size: 100% 100%;
		cursor: pointer;

		&-result {
			opacity: .8;
			cursor: pointer;
			
			&:hover {
				z-index: 9999;
				opacity: 1;
			}
		}
	}

	.card {
		z-index: 900;
		position: fixed;
		width: 400px;
		border-radius: 4px;
		background: #fff;
		box-shadow: 0 0 10px 1px rgba(0,0,0,.15);

		&-user {
			border-radius: 2px;
			padding: 12px 14px 8px;
			margin: 12px 12px 0;
			background: #F6F6F6;

			&-icon {
				width: 50px;
				height: 50px;
				margin-right: 22px;
				background: #fff;
			}

			&-name {
				font-size: 16px;
				font-weight: bold;
			}

			&-tag {
				height: 20px;
				padding: 0 4px;
				margin-left: 6px;
				font-size: 12px;
				color: #00ACA9;
				background: #E3F0F0;
			}

			&-info {
				margin-top: 5px;

				li {
					line-height: 20px;
					font-size: 13px;
					color: #333;

					label {
						white-space: nowrap;
					}
				}
			}

			&-flow {
				gap: 2px;
				margin-top: 10px;
				overflow: hidden;

				li {
					gap: 2px;
					position: relative;
					height: 22px;
					font-size: 12px;
					color: #666;
					background: #eee;

					&.z-finish {
						color: #fff;
						background: #00ACA9;
					}

					&.z-active {
						color: #00A1E9;
					}
				}
			}
		}

		&-head {
			gap: 5px;
			padding: 12px 20px 8px;

			p {
				font-size: 14px;
				font-weight: bold;
				color: var(--color-main);
			}
		}

		&-info {
			padding: 0 20px 8px;
			
			li {
				padding: 4px 0;
				line-height: 18px;
				font-size: 13px;
				color: #666;

				label {
					white-space: nowrap;
				}
			}
		}

		&-button {
			a {
				gap: 5px;
				height: 36px;
				border-top: 1px solid #eee;
				font-size: 13px;
				color: #666;

				&:nth-child(n+2) {
					border-left: 1px solid #eee;
				}

				&:hover {
					color: var(--color-main);
				}
			}
		}
	}

	>>> .c-module-fold {
		width: 100%;
		height: 24px;
		transform: translate(-50%, -50%) rotate(0deg);

		&-handle {
			position: absolute;
			left: 0;
			top: 0;
			width: 24px;
			height: 24px;
			border-radius: 50%;
			line-height: 24px;
			font-size: 12px;
			text-align: center;
			color: #00A1E9;
			background: #fff;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.2);

			&.z-fold {
				left: auto;
				right: 0;
			}

			&-next {
				transform: rotate(0deg);

				&.z-fold {
					transform: rotate(180deg);
				}
			}

			&:before {
				content: '\ed7e';
				font-family: 'iconfont';
			}
		}
	}
</style>